type VariantType = {
  name: string;
  id: string;
};

type ExperimentOptionsType = {
  variants: VariantType[];
  weights?: number[]; // Optional - weights for each variant
  defaultVariant?: VariantType; // Optional - default variant to use if experiment can't be run
  persistKey?: string; // Optional - localStorage key to persist variant choice
};

type ExperimentVariantType = {
  name: string;
  id: string;
};

export const selectExperimentVariant = (options: ExperimentOptionsType): ExperimentVariantType => {
  const { variants, weights, defaultVariant, persistKey } = options;
  let selectedVariant: VariantType;

  // Check if we have a persisted variant already
  if (persistKey) {
    const persisted = localStorage.getItem(`experiment_${persistKey}`);
    if (persisted) {
      const foundVariant = variants.find((variant) => variant.name === persisted);
      if (foundVariant) {
        return {
          name: foundVariant.name,
          id: foundVariant.id,
        };
      }
    }
  }

  // If weights are provided, use weighted random selection
  if (weights && weights.length === variants.length) {
    const totalWeight = weights.reduce((acc, weight) => acc + weight, 0);
    const random = Math.random() * totalWeight;

    let cumulativeWeight = 0;
    for (let i = 0; i < weights.length; i++) {
      cumulativeWeight += weights[i];
      if (random <= cumulativeWeight) {
        selectedVariant = variants[i];
        if (persistKey) {
          localStorage.setItem(`experiment_${persistKey}`, selectedVariant.name);
        }
        return {
          name: selectedVariant.name,
          id: selectedVariant.id,
        };
      }
    }
  }

  // Otherwise use uniform random selection
  const randomIndex = Math.floor(Math.random() * variants.length);
  selectedVariant = variants[randomIndex] ?? defaultVariant ?? variants[0];
  if (persistKey) {
    localStorage.setItem(`experiment_${persistKey}`, selectedVariant.name);
  }

  return {
    name: selectedVariant.name,
    id: selectedVariant.id,
  };
};
